<template>
  <v-footer
    color="black"
    app
  >
    <span class="white--text ml-auto mr-3">&copy; {{ new Date().getFullYear() }}</span>
    <a
      v-if="currentOffer"
      class="white--text"
      href="#"
      @click.prevent="openOfferPage"
    >
      Публичная оферта
    </a>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';
import offers from '@/api/offers';

export default {
  name: 'TheFooter',
  data() {
    return {
      currentOffer: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['hasOfferRole', 'isAuthenticated']),
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(authenticated) {
        if (!authenticated) this.currentOffer = null;
      },
    },
    hasOfferRole: {
      immediate: true,
      handler(has) {
        if (has && this.isAuthenticated && !this.currentOffer) {
          offers.getCurrent()
            .then((response) => {
              const data = response.data;
              if (data && data.code === "active_offer_not_found") return;
              this.currentOffer = data;
            })
            .catch(() => {});
        }
      },
    },
  },
  methods: {
    openOfferPage() {
      this.$router.push({ name: 'OfferView' });
    },
  },
};
</script>
